<template>
    <top-banner :depthTitle="depthTitle" :imgUrl="imgUrl" :firstTitle="firstTitle" :lastTitle="lastTitle" :breadCate="breadCate"></top-banner>
    <about-menu :isCurrent='isCurrent'></about-menu>
    <div class="ListSec">
      <div class="site-container">
          <h3 class="PageTitle">연혁</h3>
      </div>
      <div class="PgHistory">
        <div class="site-container">    
            <div class="PgHistoryList">
                <!-- Section -->
                <div class="PgHistorySec">
                    <div class="PgHistorySecYear">2026</div>
                    <div class="PgHistorySecCnt">
                        <ul class="PgHistorySecCntList">
                            <li class="PgHistorySecCntList-item">
                                <dl class="PgHistorySecCntList-inner">
                                    <dt class="PgHistorySecCntList-title">안양과천교육지원청 위(Wee)센터 학생상담마음바우처 연계 기관 선정</dt>
                                    <dd class="PgHistorySecCntList-text">청년재단 청년다다름 사업 전국 운영기관 운영자 교육 및 심리지원, 컨설팅 지원</dd>
                                    <dd class="PgHistorySecCntList-text">안양과천교육지원청 학생맞춤통합지원 교육복지안전망 무지개가족 운영</dd>
                                    <dd class="PgHistorySecCntList-text">아동양육시설 수원나자렛 양육의지혜 장기교육 진행</dd>
                                    <dd class="PgHistorySecCntList-text">한국아동복지협회 한국아동복지 세미나 연구 발표 '학대와 훈육, 그 사이의 긴장과 갈등/봄의집 지원 연구'</dd>
                                    <dd class="PgHistorySecCntList-text">청년재단과 함께하는 별빛돌봄(전문가의 전문성 교육 및 심리지원) 전국 제작소 10개 지원</dd>
                                    <dd class="PgHistorySecCntList-text">한국아동복지협회 아동 생활지도(훈육) 메뉴얼 연구</dd>
                                    <dd class="PgHistorySecCntList-text">경기도 자립지원 전담기관(북부자립지원팀) 경계선 지능 및 지적장애 지원 교육</dd>
                                    <dd class="PgHistorySecCntList-text">시흥시 은행동 주민자치회와 함께하는 STA 기질 이해를 통한 화목한 가족 정원 회복하기(무지개가족 프로그램) 진행</dd>
                                    <dd class="PgHistorySecCntList-text">서울시아동복지협회 갈등 효과적인 중재 및 소통 방법 강의</dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- //Section -->
                <!-- Section -->
                <div class="PgHistorySec">
                    <div class="PgHistorySecYear">2025</div>
                    <div class="PgHistorySecCnt">
                        <ul class="PgHistorySecCntList">
                            <li class="PgHistorySecCntList-item">
                                <dl class="PgHistorySecCntList-inner">
                                    <dt class="PgHistorySecCntList-title">함께하는 길 : 개별 맞춤 장기지원 프로젝트<br />전문가 역량강화 교육</dt>
                                    <dd class="PgHistorySecCntList-text">안양시 만안종합사회복지관 상호 협력 협정</dd>
                                    <dd class="PgHistorySecCntList-text">안양과천교육지원청 학생맞춤통합지원 교육복지안전망 ‘무지개가족’운영</dd>
                                    <dd class="PgHistorySecCntList-text">선한사마리아원, 경기도 아동일시보호소 직원역량강화 교육 </dd>
                                    <dd class="PgHistorySecCntList-text">경동원 아동의 자아성장 지원 활동 집단상담 프로그램 진행</dd>
                                    <dd class="PgHistorySecCntList-text">함께하는 길 : 개별 맞춤 통합 지원 장기 프로젝트 시작</dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- //Section -->
                <!-- Section -->
                <div class="PgHistorySec">
                    <div class="PgHistorySecYear">2024</div>
                    <div class="PgHistorySecCnt">
                        <ul class="PgHistorySecCntList">
                            <li class="PgHistorySecCntList-item">
                                <dl class="PgHistorySecCntList-inner">
                                    <dt class="PgHistorySecCntList-title">아동양육시설 역량 강화교육 장기 지원 프로그램 진행</dt>
                                    <dd class="PgHistorySecCntList-text">안양시 아동보호전문기관 협약 체결 (~현재)</dd>
                                    <dd class="PgHistorySecCntList-text">안양과천교육지원청<br /> 가족 기능강화, 학생 맞춤 성장지원 ‘무지개 가족’ 공동사업 운영</dd>
                                    <dd class="PgHistorySecCntList-text">명진들꽃사랑마을 ‘Grow up with you together’ 프로그램 운영<br /> 양육방법 개선과 자립 프로그램에 대한 교육 및 수퍼비전 (10개월)</dd>
                                    <dd class="PgHistorySecCntList-text">사회복지법인 해관재단 좋은집 업무 협약 체결<br />직원 역량강화 교육 ‘양육의 지혜’ 10회기 교육 진행</dd>
                                    <dd class="PgHistorySecCntList-text">성육보육원 아동복지시설 종사자의 역량강화 교육 진행</dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- //Section -->
                 <!-- Section -->
                <div class="PgHistorySec">
                    <div class="PgHistorySecYear">2023</div>
                    <div class="PgHistorySecCnt">
                        <ul class="PgHistorySecCntList">
                            <li class="PgHistorySecCntList-item">
                                <dl class="PgHistorySecCntList-inner">
                                    <dt class="PgHistorySecCntList-title">청년재단 위기 청년 상담 지원<br />사회복지 종사가 역량 강화 교육<br />아동양육시설 자립지원교육 및 수퍼비전</dt>
                                    <dd class="PgHistorySecCntList-text">청년재단 청년 다다름 사업 참여 청년 심리상담, 코칭 진행</dd>
                                    <dd class="PgHistorySecCntList-text">경북사회복지사협회 역량강화 교육 (ADHD, 경계선지능)</dd>
                                    <dd class="PgHistorySecCntList-text">대구광역시아동복지협회 종사자 전문성 지원 및 수퍼비전</dd>
                                    <dd class="PgHistorySecCntList-text">한국보건복지인재원 전문가 역량강화 온라인 교육 제작 (심리편)</dd>
                                    <dd class="PgHistorySecCntList-text">한국아동청소년그룹홈협의회 수퍼비전 및 동영상 교육 제작 (심리편)</dd>
                                    <dd class="PgHistorySecCntList-text">안양시 정신건강보건센터 협약 체결 (~현재)</dd>
                                    <dd class="PgHistorySecCntList-text">안양시 드림스타트 심리정서지원사업 업무 협약 (~현재)</dd>
                                    <dd class="PgHistorySecCntList-text">기쁨나눔 재단 꿈나무마을<br />양육자와 아동 간 참여형 프로그램 무지개가족 프로그램 진행</dd>
                                    <dd class="PgHistorySecCntList-text">서울시/인천시/경북 아동복지협회 아동자립지원사업단 직무역량강화</dd>
                                    <dd class="PgHistorySecCntList-text">서울특별시 아동복지협회 자립 역량강화사업<br />‘나의 자립일지 코칭 프로그램’ 6개 기관 : 기질검사 및 방문 수퍼비전</dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- //Section -->
                 <!-- Section -->
                <div class="PgHistorySec">
                    <div class="PgHistorySecYear">2022</div>
                    <div class="PgHistorySecCnt">
                        <ul class="PgHistorySecCntList">
                            <li class="PgHistorySecCntList-item">
                                <dl class="PgHistorySecCntList-inner">
                                    <dt class="PgHistorySecCntList-title">청년재단 위기 청년 상담 지원<br />느린학습자 수퍼바이저 활동 시작<br />법정 교육 : 심리 소진</dt>
                                    <dd class="PgHistorySecCntList-text">청년재단 청년 다다름 사업 참여 청년 심리상담, 코칭 진행</dd>
                                    <dd class="PgHistorySecCntList-text">한국생산성본부 종사자 법정 교육 (심리소진 및 자살 예방 교육)</dd>
                                    <dd class="PgHistorySecCntList-text">한국학교사회복지사 협회 느린 학습자 전문가 수퍼바이저 (~현재)</dd>
                                    <dd class="PgHistorySecCntList-text">한국보건복지인재원 사회복지 종사자 역량 강화 심화교육 </dd>
                                    <dd class="PgHistorySecCntList-text">한국아동복지협회 아동양육시설 종사자 역량 강화 교육 (~현재)</dd>
                                    <dd class="PgHistorySecCntList-text">아동권리보장원 종사자 역량강화 교육 (ADHD, 경계선 지능)</dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- //Section -->
                 <!-- Section -->
                <div class="PgHistorySec">
                    <div class="PgHistorySecYear">2021</div>
                    <div class="PgHistorySecCnt">
                        <ul class="PgHistorySecCntList">
                            <li class="PgHistorySecCntList-item">
                                <dl class="PgHistorySecCntList-inner">
                                    <dt class="PgHistorySecCntList-title">청년제작소 상담지원<br />민간자격 등록 및 전문가 양성<br />복지 종사자 모니터링 및 수퍼비전</dt>
                                    <dd class="PgHistorySecCntList-text">청년제작소 청년 다다름 사업 참여 청년 심리상담, 코칭 진행</dd>
                                    <dd class="PgHistorySecCntList-text">아동양육시설 청운보육원 종사자 방문 모니터링 및 집단 수퍼비전</dd>
                                    <dd class="PgHistorySecCntList-text">민간자격과정 개설 및 전문가 양성<br />- 기질분석상담사 2급, 1급 (2021-002384 주무부처: 교육부)<br />- STA 기질부모교육전문가 (2021-000189 주무부처: 여성가족부)<br />- STA 기질교육전문지도사 2급, 1급 (2021-002385 주무부처: 교육부)</dd>
                                    <dd class="PgHistorySecCntList-text">안양과천교육지원청<br />교육복지우선지원사업 가족기능강화 ‘아는 가족’ 프로그램 운영</dd>
                                    <dd class="PgHistorySecCntList-text">아동양육시설을 위한 연구, 인터뷰, 매뉴얼 도서 발간 (현재까지 3권)</dd>
                                    <dd class="PgHistorySecCntList-text">울산교육지원청 강북교육지원청 ‘기질이해를 통한 나와 너의 존중’ 교육</dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- //Section -->
                 <!-- Section -->
                <div class="PgHistorySec">
                    <div class="PgHistorySecYear">2020</div>
                    <div class="PgHistorySecCnt">
                        <ul class="PgHistorySecCntList">
                            <li class="PgHistorySecCntList-item">
                                <dl class="PgHistorySecCntList-inner">
                                    <dt class="PgHistorySecCntList-title">청년 제작소 위기 청년 상담 지원<br />법정 교육 : 심리 문제 및 자살 예방<br />복지 전문가 역량 강화 교육</dt>
                                    <dd class="PgHistorySecCntList-text">청년제작소 청년 다다름 사업 참여 청년 심리상담, 코칭 진행</dd>
                                    <dd class="PgHistorySecCntList-text">한국연예매니지먼트협회 법정 교육 ‘심리 문제 및 자살 예방 교육’</dd>
                                    <dd class="PgHistorySecCntList-text">한국보건복지인재원 역량 강화 교육 기초, 심화편 장기 지원 (~현재)</dd>
                                    <dd class="PgHistorySecCntList-text">안양과천교육지원청 공동사업(무지개가족) 진행</dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- //Section -->
                 <!-- Section -->
                <div class="PgHistorySec">
                    <div class="PgHistorySecYear">2019</div>
                    <div class="PgHistorySecCnt">
                        <ul class="PgHistorySecCntList">
                            <li class="PgHistorySecCntList-item">
                                <dl class="PgHistorySecCntList-inner">
                                    <dt class="PgHistorySecCntList-title">연성대학교 협력 체결<br />교육지원청 전문가 연수 <br />법정 교육 : 의사소통 관련</dt>
                                    <dd class="PgHistorySecCntList-text">연성대학교 산학협력 체결</dd>
                                    <dd class="PgHistorySecCntList-text">성남 교육지원청 교사연수 ‘정서행동코칭’</dd>
                                    <dd class="PgHistorySecCntList-text">안양과천교육지원청 학교사회복지사 역량강화 워크숍 ‘정서행동코칭‘</dd>
                                    <dd class="PgHistorySecCntList-text">한국연예매니지먼트협회 법정 교육 3회 ‘기질과 커뮤니케이션’</dd>
                                    <dd class="PgHistorySecCntList-text">한국생산성본부 대중문화예술기획업 종사자 법정 교육 ‘커뮤니케이션’</dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- //Section -->
                 <!-- Section -->
                <div class="PgHistorySec">
                    <div class="PgHistorySecYear">2018</div>
                    <div class="PgHistorySecCnt">
                        <ul class="PgHistorySecCntList">
                            <li class="PgHistorySecCntList-item">
                                <dl class="PgHistorySecCntList-inner">
                                    <dt class="PgHistorySecCntList-title">STA기질검사 저작권 등록<br />기질캠프 프로그램 개발과 운영<br />유아교사 대상 심리지원교육</dt>
                                    <dd class="PgHistorySecCntList-text"> STA자기발견 기질검사 저작권 등록</dd>
                                    <dd class="PgHistorySecCntList-text">TEP(Therapy and Education Program) 치료-교육 프로그램 개발</dd>
                                    <dd class="PgHistorySecCntList-text">UNAI 유엔아카데믹 한국협의회 <br />F-GCED 사업 자녀 프로그램 개발 연구 및 1박 2일 기질캠프 운영</dd>
                                    <dd class="PgHistorySecCntList-text">대전 연합 유치원 교사 심리 지원 교육 프로그램 운영 </dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- //Section -->
                 <!-- Section -->
                <div class="PgHistorySec">
                    <div class="PgHistorySecYear">2017</div>
                    <div class="PgHistorySecCnt">
                        <ul class="PgHistorySecCntList">
                            <li class="PgHistorySecCntList-item">
                                <dl class="PgHistorySecCntList-inner">
                                    <dt class="PgHistorySecCntList-title">위드유치료교육연구소 설립<br />안양시 교육기관 협력 체결<br />사회복지 전문가 역량 강화 교육</dt>
                                    <dd class="PgHistorySecCntList-text">위드유치료교육연구소 설립</dd>
                                    <dd class="PgHistorySecCntList-text">안양시 소재 시립어린이집 MOU 협약 체결 (현재 25개 기관,~현재)</dd>
                                    <dd class="PgHistorySecCntList-text">천주교 재단 서울대교구 청소년국 유아교사 자격연수</dd>
                                    <dd class="PgHistorySecCntList-text">영원한 도움의 성모수도회 교사심화연수 ‘인식과 행동사이-심리이해’</dd>
                                    <dd class="PgHistorySecCntList-text">서울특별시아동복지협회 아동자립지원사업단 2017 직무역량강화교육</dd>
                                    <dd class="PgHistorySecCntList-text">UNAI 유엔 아카데믹 한국 협의회<br />F-GCED 사업 자녀 프로그램 개발 연구 및 1박 2일 캠프 운영</dd>
                                    <dd class="PgHistorySecCntList-text">대전성심유치원 교사 심리 분석 및 교사심화 연수</dd>
                                    <dd class="PgHistorySecCntList-text">동방사회복지관 서대문아이존 열린 직원교육 ‘상담기법’</dd>
                                    <dd class="PgHistorySecCntList-text">청운보육원 직원 역량 교육</dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- //Section -->
            </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import {computed, reactive } from 'vue'
  import { useHead } from '@vueuse/head'
  import TopBanner from "../components/topbanner/topbanner.vue";
  import AboutMenu from "../components/aboutmenu/aboutmenu.vue";


  export default {
    name:'Researcher',
    setup() {
        const siteData = reactive({
        title: `연혁 - WithYou 위드유치료교육연구소`,
        description: 'WithYou 위드유치료교육연구소 연혁을 소개합니다.',
        canonical: 'https://withyoulove.co.kr/About/History',
        })
        useHead({
            title: computed(() => siteData.title),
            meta: [
                    {
                        name: `description`,
                        content: computed(() => siteData.description),
                    },
            ],
            link: [
                {
                    rel: `canonical`,
                    content: computed(() => siteData.canonical),
                },
            ]
        })
    },
    components: {
      TopBanner,
      AboutMenu,
    },
    data() {
          return {
             //상단 배너 컨텐츠
              depthTitle:'연구소 소개',
              imgUrl:'../../images/view/topbanner/topbanner-re.png',
              firstTitle:"연구소 소개",
              lastTitle:'연혁',
              breadCate:'About',

              //서브메뉴
              isCurrent:'2',
          };
      },
      mounted() {
        
      },
      methods:{
        
      }
  }
  </script>
  